import type { Incident } from "../lib/api";
import { Markdown } from "./Markdown";

function formatWhen(ts: string | undefined): string {
  if (!ts) return "";
  try {
    const dt = new Date(ts);
    return dt.toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return ts;
  }
}

export function IncidentList({
  title,
  incidents,
  emptyMessage,
}: {
  title: string;
  incidents: Incident[];
  emptyMessage: string;
}) {
  return (
    <section className="mt-8" aria-labelledby="incident-list-heading">
      <h2 id="incident-list-heading" className="text-lg font-semibold">
        {title}
      </h2>
      {incidents.length === 0 ? (
        <p className="mt-3 text-slate-600">{emptyMessage}</p>
      ) : (
        <ol className="mt-3 space-y-4">
          {incidents.map((inc) => (
            <li
              key={inc.incident_id}
              className="rounded-lg border border-slate-200 bg-white p-4"
            >
              <header className="flex items-start justify-between">
                <div>
                  <h3 className="font-semibold">
                    {inc.is_maintenance ? "[Maintenance] " : ""}
                    {inc.title}
                  </h3>
                  <p className="mt-1 text-xs uppercase tracking-wide text-slate-500">
                    {inc.severity} &middot; {inc.status}
                    {inc.affected_components.length > 0
                      ? ` \u00b7 ${inc.affected_components.join(", ")}`
                      : ""}
                  </p>
                </div>
                <time className="text-xs text-slate-500">
                  {formatWhen(inc.started_at)}
                </time>
              </header>
              <ol className="mt-3 space-y-2 border-l-2 border-slate-200 pl-4">
                {inc.updates.map((u) => (
                  <li key={u.version}>
                    <p className="text-xs uppercase tracking-wide text-slate-500">
                      {u.status}
                    </p>
                    <Markdown text={u.body_markdown} className="text-sm" />
                  </li>
                ))}
              </ol>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
